/* __next_internal_client_entry_do_not_use__ default auto */ import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useNewOrder } from '@/context/NewOrderContext';
import React from 'react';
import { CircularProgress } from "__barrel_optimize__?names=CircularProgress!=!@mui/material";
import { doc, updateDoc } from 'firebase/firestore';
import { firestore } from '@/lib/firebase/firebase';
function Addons() {
    const { order, setOrder, addons } = useNewOrder();
    const handleToggleAddon = (addonId)=>{
        var _order_add_ons;
        const addon = addons.find((addon)=>addon.id === addonId);
        if (!addon) return;
        const isSelected = (_order_add_ons = order.add_ons) === null || _order_add_ons === void 0 ? void 0 : _order_add_ons.some((selected)=>selected.id === addonId);
        if (isSelected) {
            setOrder((prev)=>{
                var _prev_add_ons;
                return {
                    ...prev,
                    add_ons: ((_prev_add_ons = prev.add_ons) === null || _prev_add_ons === void 0 ? void 0 : _prev_add_ons.filter((selected)=>selected.id !== addonId)) || []
                };
            });
            if (order.id) {
                var _order_add_ons1;
                const docRef = doc(firestore, 'orders', order.id);
                updateDoc(docRef, {
                    add_ons: ((_order_add_ons1 = order.add_ons) === null || _order_add_ons1 === void 0 ? void 0 : _order_add_ons1.filter((selected)=>selected.id !== addonId)) || []
                });
            }
        } else {
            setOrder((prev)=>({
                    ...prev,
                    add_ons: [
                        ...prev.add_ons || [],
                        addon
                    ]
                }));
            if (order.id) {
                const docRef = doc(firestore, 'orders', order.id);
                updateDoc(docRef, {
                    add_ons: [
                        ...order.add_ons || [],
                        addon
                    ]
                });
            }
        }
    };
    if (addons.length === 0) {
        return /*#__PURE__*/ _jsx("div", {
            className: "h-[50vh] flex items-center justify-center",
            children: /*#__PURE__*/ _jsx(CircularProgress, {})
        });
    } else {
        return /*#__PURE__*/ _jsxs("div", {
            className: "mt-10",
            children: [
                /*#__PURE__*/ _jsx("div", {
                    children: /*#__PURE__*/ _jsx("span", {
                        className: "text-xl",
                        children: "Add-Ons:"
                    })
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "flex flex-wrap flex-row gap-5 mt-5",
                    children: addons.map((addon, index)=>{
                        var _order_add_ons, _addon_default_price;
                        return /*#__PURE__*/ _jsx("div", {
                            className: "w-full sm:w-[400px] rounded-xl p-4 border cursor-pointer ".concat(((_order_add_ons = order.add_ons) === null || _order_add_ons === void 0 ? void 0 : _order_add_ons.some((selected)=>selected.id === addon.id)) ? 'border-cyan bg-cyan/10' : 'hover:bg-neutral-100 border-neutral-300'),
                            onClick: ()=>handleToggleAddon(addon.id),
                            children: /*#__PURE__*/ _jsxs("div", {
                                children: [
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "flex items-center justify-center mb-5",
                                        children: addon.images.length > 0 ? /*#__PURE__*/ _jsx("img", {
                                            src: addon.images[0],
                                            alt: addon.name,
                                            className: "h-20 object-contain"
                                        }) : /*#__PURE__*/ _jsx("div", {
                                            className: "h-20 flex items-center justify-center bg-neutral-200 rounded",
                                            children: /*#__PURE__*/ _jsx("span", {
                                                className: "text-sm text-neutral-500",
                                                children: "No Image"
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: "text-center",
                                        children: [
                                            /*#__PURE__*/ _jsx("span", {
                                                className: "font-semibold",
                                                children: addon.name
                                            }),
                                            /*#__PURE__*/ _jsx("p", {
                                                className: "text-sm text-neutral-500 my-3",
                                                children: addon.description ? addon.description : 'No description available'
                                            }),
                                            /*#__PURE__*/ _jsx("span", {
                                                children: ((_addon_default_price = addon.default_price) === null || _addon_default_price === void 0 ? void 0 : _addon_default_price.unit_amount) ? "$".concat((addon.default_price.unit_amount / 100).toFixed(2)) : 'Price not available'
                                            })
                                        ]
                                    })
                                ]
                            })
                        }, index);
                    })
                })
            ]
        });
    }
}
export default Addons;
